import React from 'react'

const VirtualQuizEvents = () => {
  return (
    <></>
  )
}

export default VirtualQuizEvents